import {QUERY_PARAMETER_TEMPLATE_OVERRIDE} from "@next/utils"
import {QUERY_PARAMETER_IMAGE_RATIO} from "../../config/constants"
import typeofQueryParamToAdd from "../typeofQueryParamToAdd"

export interface QueryParams {
    productSummaryTemplateName?: string | undefined
    imageRatio?: string | undefined
}

function constructProductSummaryOverrideURL(oldURL: string, {productSummaryTemplateName, imageRatio}: QueryParams) {
    let newURL = oldURL

    if (productSummaryTemplateName) {
        newURL += typeofQueryParamToAdd(newURL, `${QUERY_PARAMETER_TEMPLATE_OVERRIDE}=${productSummaryTemplateName}`)
    }
    if (imageRatio) {
        newURL += typeofQueryParamToAdd(newURL, `${QUERY_PARAMETER_IMAGE_RATIO}=${imageRatio}`)
    }

    return newURL
}

export default constructProductSummaryOverrideURL
